module.exports = __webpack_public_path__ + "img/10.ed8bfb43.png";